let cfg = { currency: "BRL", locale: "pt-BR", dateFormat: "DD/MM/YYYY" };

export function setFormatConfig(next) {
  cfg = {
    currency: next?.currency || "BRL",
    locale: next?.locale || "pt-BR",
    dateFormat: next?.date_format || next?.dateFormat || "DD/MM/YYYY",
  };
}

export const formatBRL = (v) =>
  v == null
    ? "—"
    : new Intl.NumberFormat(cfg.locale, { style: "currency", currency: cfg.currency }).format(v);

export const formatNum = (v) =>
  v == null ? "—" : new Intl.NumberFormat(cfg.locale).format(v);

export const formatPct = (v) =>
  v == null
    ? "N/A"
    : `${new Intl.NumberFormat(cfg.locale, { minimumFractionDigits: 1, maximumFractionDigits: 2 }).format(v)}%`;

export const formatDate = (s) => {
  if (!s) return "—";
  const d = new Date(s.length <= 10 ? s + "T00:00:00" : s);
  if (isNaN(d)) return "—";
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  return cfg.dateFormat.replace("DD", dd).replace("MM", mm).replace("YYYY", yyyy);
};

export const formatDateTime = (s) => {
  if (!s) return "—";
  const d = new Date(s);
  if (isNaN(d)) return "—";
  return `${formatDate(s)} ${d.toLocaleTimeString(cfg.locale, { hour: "2-digit", minute: "2-digit" })}`;
};

export const parseDecimal = (v) => {
  if (v === null || v === undefined) return NaN;
  let s = String(v).trim();
  if (s === "") return NaN;
  if (s.includes(",")) s = s.replace(/\./g, "").replace(",", ".");
  return parseFloat(s);
};
